import { render, staticRenderFns } from "./GlobalVariableManage.vue?vue&type=template&id=202ba67b"
import script from "./GlobalVariableManage.vue?vue&type=script&lang=js"
export * from "./GlobalVariableManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports